import Constants from "../../../../../constants/Constants";
import axios from "axios/index";
import {handleAuthenticationFailure, appendHttpUrlToApi} from "../../../../../utility/Utility";


export function xhrGetBoostJobDetails(jobId, onSuccess, onFailure) {
    if(Constants.DEV_MODE){
        requestDummyType1(jobId, onSuccess);
        return;
    }
    axios({
        timeout: Constants.REQ_TIMEOUT,
        method: 'get',
        url: appendHttpUrlToApi(Constants.ROUTE.RECRUITER_DASHBOARD_COMMON_HANDLER),
        params: {
            job_id: jobId,
            action_type: Constants.REQUEST_ACTION_TYPE.RECRUITER_DASHBOARD_COMMON_HANDLER.GET_ACTION_GET_BOOST_DETAILS_FOR_JOB

        }
    }).then( res =>{
        let data = res.data.data ;
        onSuccess(data);
    }).catch((error)=>{
        onFailure();
    });
}

export function xhrBoostJob(data, onSuccess, onFailure) {

    if(Constants.DEV_MODE){
        requestDummyType2(data, onSuccess);
        return;
    }
    data.append("action_type",Constants.REQUEST_ACTION_TYPE.RECRUITER_DASHBOARD_COMMON_HANDLER.GET_ACTION_BOOST_JOB);

    axios({
        timeout: Constants.REQ_TIMEOUT,
        method: 'post',
        url: appendHttpUrlToApi(Constants.ROUTE.RECRUITER_DASHBOARD_COMMON_HANDLER),
        data: data
    }).then( res => {
        let data = res.data.data;
        if(res.data && res.data.error === null) {
            let authVo = res.data.authentication_result;
            if(authVo.is_active_user && authVo.is_valid_user && authVo.is_valid_token) {
                onSuccess(data);
            }
            else{
                handleAuthenticationFailure()
            }
        }
        else {
            onFailure();
        }
    }).catch((error)=>{
        onFailure();
    });
}

export function xhrGetCoinsInfo (data, onSuccess, onFailure) {
    
    axios({
        timeout: Constants.REQ_TIMEOUT,
        method: 'get',
        url: appendHttpUrlToApi(Constants.ROUTE.RECRUITER_DASHBOARD_COMMON_HANDLER),
        params: {
            flow_id: data.actionForCoins,
            job_id: data.jobId,
            action_type: Constants.REQUEST_ACTION_TYPE.RECRUITER_DASHBOARD_COMMON_HANDLER.GET_ACTION_GET_COINS_INFO,
        }
    }).then( res => {
        let data = res.data.data;
        if(res.data && res.data.error === null) {
            let authVo = res.data.authentication_result;
            if(authVo.is_active_user && authVo.is_valid_user && authVo.is_valid_token) {
                onSuccess(data);
            }
            else{
                handleAuthenticationFailure()
            }
        }
        else {
            onFailure();
        }
    }).catch((error)=>{
        onFailure();
    });
}

export function xhrGetCtcInfo (jobId, onSuccess, onFailure) {
    // if(Constants.DEV_MODE){
    //     requestDummyType1(profileId, onSuccess);
    //     return;
    // }
    axios({
        timeout: Constants.REQ_TIMEOUT,
        method: 'get',
        url: appendHttpUrlToApi(Constants.ROUTE.RECRUITER_DASHBOARD_COMMON_HANDLER),
        params: {
            job_id: jobId ,
            action_type: Constants.REQUEST_ACTION_TYPE.RECRUITER_DASHBOARD_COMMON_HANDLER.GET_ACTION_GET_BOOST_DETAILS_FOR_JOB,
        }
    }).then( res => {
        let data = res.data.data;
        if(res.data && res.data.error === null) {
            let authVo = res.data.authentication_result;
            if(authVo.is_active_user && authVo.is_valid_user && authVo.is_valid_token) {
                onSuccess(data);
            }
            else{
                handleAuthenticationFailure()
            }
        }
        else {
            onFailure();
        }
    }).catch((error)=>{
        onFailure();
    });
}

function requestDummyType1(params, onSuccess) {
    window.CompanyJob.forEach((item, index) => {
        if(params.id === item.id) {
            onSuccess(window.CompanyJob[index]);
        }
    });
}

function requestDummyType2(data, onSuccess) {
    let CompanyJobList = window.CompanyJob, boostJob;
    let compId = parseInt(data.get("id")), indx;
    boostJob = {
        id: (data.get("id") !== "null") ? parseInt(data.get("id")) : null,
        companyLogoUrl:(data.get("companyLogoUrl") !== "null") ? JSON.parse(data.get("companyLogoUrl")) : null,
        jobDesignation: (data.get("jobDesignation") !== "null") ? data.get("jobDesignation") : null,
        companyName: (data.get("companyName") !== "null") ? data.get("companyName") : null,
        locationList: (data.get("locationList") !== "null") ? JSON.parse(data.get("locationList")) : null,
        coinsRequired: (data.get("coinsRequired") !== "null") ? data.get("coinsRequired") : null,
        rate: (data.get("rate") !== "null") ? data.get("rate") : null,
        totalPricing: (data.get("totalPricing") !== "null") ? data.get("totalPricing") : null
    };
    CompanyJobList.forEach((item, index) => {
        if(item.id === compId) {
            indx = index
        }
    });
    let test = CompanyJobList[indx] = {...CompanyJobList[indx], ...boostJob};

    let timer = setTimeout(()=> {
        onSuccess(test);
    }, 1000);

    // return function () {
    //     clearTimeout(timer);
    //     console.log("dummy request canceled");
    // };
}


// WEBPACK FOOTER //
// ./src/components/GetMoreProfilesModal/Components/GetBoostJob/Services/Services.js